<template>
    <div v-if="showFlag" class="flag">
        <div class="fixed flex center middle between">
            <div class="content flex-1">
                <p>
                    <b>Não detectamos nenhuma Visualização nas suas Páginas nos últimos 30 dias</b>!
                </p>
                <p>
                    Pode levar até 20 minutos para a detecção das primeiras visitas.
                </p>
                <p class="margin-top-s">
                    Faça o teste de verificação da TAG Hot Tracker para validar se está instalada corretamente!
                </p>
                <div class="">
                    <div class="button primary margin-top-s" @click="closeMessage()">Fechar</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapState } from "vuex";

export default {
    name: 'flag-tag-empty',
    props: ['show'],
    data() {
        return {
            showFlag: false
        }
    },
    mounted() {
        this.showFlag = this.show
    },
    watch: {
        show() {
            this.showFlag = this.show
        }
    },
    computed: {
        ...mapState({
            account: (state) => state.account,
        }),
    },
    methods: {
        closeMessage() {
            this.$emit('close', false)
        }
    }
}
</script>

<style lang="scss" scoped>
.flag {
    margin-bottom: 60px
}
.fixed {
    position: absolute;
    z-index: 2;
    top: 0px;
    left: 80px;
    width: 100%;
    color: #333;
    background: #f79b06;
    height: auto;


    .content {
        width: 100%;
        text-align: left;
        font-size: 14px;
        min-height: 70px;
        height: auto;
        padding: 15px 90px 5px 5px;
        text-align: center;
    }

    .icon {
        margin-left: 90px;
        width: 70px;
        padding: 5px;
        font-size: 36px;
    }
}

@media screen and (max-width: 1024px) {
   .flag {
        margin-bottom: 110px;
    }
  .fixed {
    left:0px;
    .content {
        padding: 15px 30px 10px 10px;
    }
  }

}
</style>

<style>

@media screen and (max-width: 1024px) {
    .sidebar.isdemo {
        top: 115px !important;
    }
}
</style>
